


<template>
<div class="review-issue-spill-pullout pullout-panel">
  <div class="bkg"></div>
  <div class="review-issue-spill-list">


    <div class="review-issue-spill-scroll" v-if="!detailPanel">
      <img class="w-full" src="/img/screens/hr/pullouts/pullout-my-issues-erin.png?v=10122022" />
      <div class="links">
        <screen-link left="92.5%" top="1%" width="6%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
        <screen-link left="75%" top="81.5%" width="20%" height="5%" data-tgt="erin-details" dot-class="dot-right-center" data-is-overlay="true" @click.native="showDetails"></screen-link>
      </div>
    </div>
    <div class="review-issue-spill-scroll" v-if="detailPanel === 'michael'">
      <img class="w-full" src="/img/screens/hr/pullouts/pullout-my-issues-michael.png?v=10122022" />
      <div class="links">
        <screen-link left="92.5%" top="1%" width="6%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>

      </div>
    </div>
    <div class="review-issue-spill-scroll" v-if="detailPanel === 'erin-details'">
      <img class="w-full" src="/img/screens/hr/pullouts/pullout-hr-issues-incident-add-details.png?v=10122022" />
      <div class="links">
        <screen-link left="1%" top="1%" width="30%" height="4%" data-tgt="" dot-class="dot-left-center" data-is-overlay="true" @click.native="showDetails"></screen-link>
        <screen-link left="92.5%" top="1%" width="6%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
      </div>
    </div>


  </div>



</div>
</template>

<script>
import ScreenLink from "@/components/ScreenLink";
export default {
    name: "review-issues-pullout",
  components: {ScreenLink},
  props: {},
    data: function(){
        return {
          detailPanel: null
        }
        },
    mounted() {
      if(this.$route.query.level !== undefined){
        this.detailPanel = this.$route.query.level;
      }
    },

    watch: {
      $route: function(next){
        if(next.query.level !== undefined){
          this.detailPanel = next.query.level;
        }
      }
    },

    methods: {
      showDetails: function(e){
          this.detailPanel = e.target.dataset.tgt;
let query = {...this.$route.query};
          query.level=e.target.dataset.tgt;
          this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query });
      },

      onLinkClick: function(e){
        console.log(e);
        this.$emit('link', e);
      }
    },
    computed: {}
}
</script>

<style scoped>


.review-issue-spill-pullout {
  width: 100%;
  position: absolute;
  top: calc((60/920) * 100%);
  height: calc(((920 - 60)/920) * 100%);

}

.review-issue-spill-pullout .bkg {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: black;
  opacity: 0.4;
}

.review-issue-spill-pullout img {
  display: block;
}

.review-issue-spill-pullout bkg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 0.4;

}

.review-issue-spill-list {

  position: absolute;
  width: calc((600/1580) * 100% + 15px);
  height: 100%;

  right: 0;
  display: flex;
  flex-direction: column;

}



.review-issue-spill-scroll {
  position: relative;

  overflow-y: scroll;
}

.w-full {
  width: 100%;
}

.links {

}

</style>
